module.exports = __webpack_public_path__ + "static/images/smartspot-performance-es.4e4f05d1666af9b1671714238f430b2e.png";